import { gql } from '@apollo/client';

const REPORT_STATUS_QUERY = gql`
  query reportStatus($id: ID!) {
    report(id: $id) {
      id
      statusReport
      lastStatusReportAt
    }
  }
`;

export default REPORT_STATUS_QUERY;
